// import Main from '@/view/main'

export default {
  path: "sales",
  meta: {
    title: "客户管理"
  },
  name: "sales",
  component: () => import("@/components/parent-view"),
  children: [
    {
      path: "business",
      name: "sales-business",
      meta: {
        title: "项目管理"
      },
      component: () => import("@/view/v5/sales/business/index.vue")
    },
    {
      path: "customer",
      name: "sales-customer",
      meta: {
        title: "客户管理"
      },
      component: () => import("@/view/v5/sales/customer/index.vue")
    },
    {
      path: "customer/corporate/index",
      name: "customer-corporate",
      meta: {
        title: "企业花名册"
      },
      component: () => import("@/view/v5/sales/customer/corporate/index.vue")
    },
    {
      path: "customer/add/selfCustomer",
      name: "add-self-customer",
      meta: {
        title: "新增自建客户"
      },
      component: () => import("@/view/v5/sales/customer/add/self-customer.vue")
    },
    {
      path: "customer/add/selfCustomer/:orgId",
      name: "edit-self-customer",
      meta: {
        title: "编辑自建客户"
      },
      component: () => import("@/view/v5/sales/customer/add/self-customer.vue")
    },
    {
      path: "customer/add/project/:orgId/:id",
      name: "edit-self-project",
      meta: {
        title: "编辑项目"
      },
      component: () => import("@/view/v5/sales/customer/add/project.vue")
    },
    {
      path: "customer/add/project/:orgId",
      name: "add-self-project",
      meta: {
        title: "新增项目"
      },
      component: () => import("@/view/v5/sales/customer/add/project.vue")
    },
    {
      path: "invioce/ticket/:orgId",
      name: "invoice-detail",
      meta: {
        title: "增票资质"
      },
      component: () => import("@/view/v5/sales/customer/invioce/ticket.vue")
    },
    {
      path: "invioce/:purchaseId",
      name: "invoice-detail",
      meta: {
        title: "增票机制"
      },
      component: () => import("@/view/v5/sales/customer/invioce/invoice.vue")
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/routes/v5/sales.js